export const getCurrencyValue = (currencyString: string): number => {
  const britishNumberFormat = currencyString.replace(",", ".");
  const valueWithoutSymbol = +britishNumberFormat.replace(/[^0-9.-]+/g, "");

  return valueWithoutSymbol;
};
